import React, {Component} from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import ProgressBar from "./progress-bar";
import {NavLink} from "react-router-dom";

const propTypes = {
	date_finish: PropTypes.string.isRequired,
	category: PropTypes.object.isRequired,
	duration: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired,
	steps: PropTypes.number.isRequired,
	filter: PropTypes.string
}

class TaskCard extends Component {
    render() {
	    let stat = _.find(this.props.statusList, {id: this.props.status});
        return <div className={`task-card ${(stat.slug === this.props.filter || this.props.filter === undefined) ? 'show' : ''}`}>
            <div className="task-card--dates">
                <p className="date">{this.props.date_finish}</p>
                <div className="progress-bar small">
                    <ProgressBar total={stat.slug === 'sin-iniciar' ? 0 : 25} />
                </div>
            </div>
            <NavLink to={`/cdm/tarea/${this.props.id}`} className={`task-card--details ${this.props.category.style}`}>
                <div className="header">
                    <p className="header--category">
                        {this.props.category.name}
                    </p>
                    <p className="header--duration">
                        {this.props.duration} días
                    </p>
                </div>
                <div className="content">
                    <div className="content--info">
                        {this.props.title}
                    </div>
                </div>
                <div className="footer">
                    <div className="footer--item">{this.props.steps} pasos</div>
                    <div className={`footer--item has-text-${stat.style}`}>{stat.title}</div>
                </div>
            </NavLink>
        </div>
    }
}

TaskCard.propTypes = propTypes;

export default TaskCard;


// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/widgets/task-card.jsx